import { makeFilterString } from "../utils/Helper";
import {
  PromoCodesLoading,
  GetPromoCodesSuccess,
  GetPromoCodeDetailsSuccess,
} from "./Action";

import { reduxRequest } from "common/utils/reduxRequest";

export const getPromoCodesRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: PromoCodesLoading,
    loadingType: "list",
    successFunction: GetPromoCodesSuccess,
    url: `/admin/promo_codes${makeFilterString(variables?.params)}`,
    method: "get",
  };

  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const createPromoCodeRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: PromoCodesLoading,
    loadingType: "create",
    action: variables?.action,
    url: `/admin/promo_codes`,
    data: variables?.body,
    method: "post",
  };

  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const getPromoCodeDetailsRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: PromoCodesLoading,
    loadingType: "get",
    successFunction: GetPromoCodeDetailsSuccess,
    action: variables?.action,
    url: `/admin/promo_codes/${variables?.id}`,
    method: "get",
  };

  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const updatePromoCodeRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: PromoCodesLoading,
    loadingType: "update",
    action: variables?.action,
    url: `/admin/promo_codes/${variables?.id}`,
    data: variables?.body,
    method: "put",
  };

  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const deletePromoCodeRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: PromoCodesLoading,
    loadingType: "delete",
    action: variables?.action,
    url: `/admin/promo_codes/${variables?.id}`,
    method: "delete",
  };

  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};
